import React from "react";
import { observer } from "mobx-react";

export const SavedStage = observer(function SavedStage({ controller, onRunWorkflow }) {
  const pb = controller.playbook || {};
  const stepCount = (pb.steps || []).length;
  const paramCount = (pb.parameters || []).length;
  const id = controller.lastSavedWorkflowId;
  return (
    <div className="cua-saved-stage">
      <div className="cua-check" aria-hidden="true">✓</div>
      <div className="cua-saved-name">"{pb.name}"</div>
      <div className="cua-saved-sub">
        Added to your Library · {stepCount} step{stepCount === 1 ? "" : "s"}
        {paramCount > 0 && ` · ${paramCount} parameter${paramCount === 1 ? "" : "s"}`}
      </div>
      <div className="cua-saved-hint">
        To change this workflow, record a new version — editing saved workflows is coming soon.
      </div>
      <div className="cua-saved-actions">
        <button
          type="button"
          className="copilot-modal-btn copilot-modal-btn--ghost"
          onClick={() => controller.closeWizard()}
        >
          Close
        </button>
        <button
          type="button"
          className="copilot-modal-btn copilot-modal-btn--primary"
          disabled={id == null}
          onClick={() => onRunWorkflow && onRunWorkflow(id)}
        >
          ▶ Run now
        </button>
      </div>
    </div>
  );
});
